module.exports = __webpack_public_path__ + "dfdf3c4bc599fc6b51809d069657600e.png";